import { Command } from '@nextforce/api'
import { useRoutingContext } from 'app/routing_context'
import { useCreateDirectConversation } from 'chat/conversations/queries/create_direct'
import { sendDirectMessage } from 'chat/conversations/utils'
import { UserProfileScreenProps } from 'home/stack/types'
import React, { useCallback } from 'react'
import { Linking, Platform } from 'react-native'
import { StatusBoundary } from 'shared/components/status_boundary'
import { usePerformUserProfileAction } from 'users/queries/perform_profile_action'
import { useUserProfile } from 'users/queries/profile'
import { UserProfileView } from './view'

export function UserProfileScreen({
  navigation,
  route,
}: UserProfileScreenProps) {
  const { uri } = route.params
  const { handleNavigation } = useRoutingContext()
  const query = useUserProfile(uri)
  const mutation = usePerformUserProfileAction(uri)
  const createDirectConversationMutation = useCreateDirectConversation()

  const onCommandButtonPress = useCallback(
    async (command: Command) => {
      if (command.type === 'action') {
        if (command.name === 'invite_user') {
          handleNavigation({
            routeName: 'add_mobile_number',
            routeParams: {
              action: command.action,
              uri,
            },
          })
        } else if (command.name === 'dm') {
          const recipientId = command.action.params?.recipient_id
          await sendDirectMessage(
            navigation,
            createDirectConversationMutation,
            recipientId
          )
        } else {
          await mutation.mutateAsync(command.action)
        }
      } else if (command.type === 'sms') {
        const seperator = Platform.OS === 'ios' ? '&' : '?'
        await Linking.openURL(
          `sms:${command.phoneNumber}${seperator}body=${command.body ?? ' '}`
        )
      } else {
        //Handle any other actions if any
        return
      }
    },
    [
      createDirectConversationMutation,
      handleNavigation,
      mutation,
      navigation,
      uri,
    ]
  )

  return (
    <StatusBoundary isLoading={query.isLoading} error={query.error}>
      <UserProfileView
        profile={query.data}
        onCommandButtonPress={onCommandButtonPress}
      />
    </StatusBoundary>
  )
}
